import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  azure: {
    clientId: '5bcfabbd-5945-4805-9749-58df7a7f49ed',
    tenantId: 'f2baf195-6705-441b-912a-3b2997d976fd',
    redirectUri: 'https://tracpass.dev.onrsr.com.au/',
  },
  logging: {
    level: NgxLoggerLevel.INFO,
    serverLogLevel: NgxLoggerLevel.WARN,
  },
  apiHost: 'https://nr-ae-sb-tracpass-dev-app-aadcavdhfgc0a5f7.australiaeast-01.azurewebsites.net/api',
};
